module.exports = __webpack_public_path__ + "src/img/autoChecker.a0e65efb.svg";